import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function getAdminUserProjectreducer(state = initialState.adminUserProject, action) {
	switch (action.type) {
		case types.GET_ADMIN_USER_PROJECT: {
			return action.response;
		}
		case types.CLEAR_ADMIN_USER: {
			return initialState.adminUserProject;
		}
		default:
			return state;
	}
}
